<template>
  <div :class="[this.$root.whatEev == 'miniprogram' ? 'minichat' : '']">
    <div class="majorSenior" :class="{ inApp: $root.$data.isApp, fix: searchVal && showSearch }">
    <div class="top-head">
      <div class="title">
        <img v-if="this.$root.whatEev!='miniprogram'" class="back" @click="back" src="../../assets/img/majorSenior/back1.png" alt="" />
        <img class="bg" src="../../assets/img/majorSenior/bg2.png" alt="" />
        <SchoolCard :shchoolInfo="shchoolInfo" />
        <div class="search">
          <van-field
            v-model.trim="searchVal"
            type="input"
            clearable
            maxlength="20"
            @input="change"
            placeholder="请输入您的目标专业"
          />
        </div>
        <div class="schoolList" v-if="showSearch && searchVal" @click.stop="closeBg($event)">
          <div>
            <div
              :class="selected === index ? 'active' : ''"
              @click="addClass(index, item)"
              v-for="(item, index) in searchList"
              :key="index"
            >
              {{ item }}
            </div>
            <EmptyData :emptyName="'noEvaluation'" v-if="showSearch && !searchList.length" />
          </div>
        </div>
      </div>
    </div>

    <div class="mainBox" v-if="!listEmpty">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div
          class="seniorBox"
          v-for="(item, index) in seniorList"
          :key="index"
          @click="goSeniorDetail(item.id, item.nickName, item)"
        >
          <div class="headerIcon">
            <img :src="item.avatar || defaultHead" alt="avatar" />
          </div>
          <div class="seniorInfo">
            <h2>{{ item.nickName }}</h2>
            <div class="schoolDetail">
              <span>{{ item.pgCollege }}</span>
              <span v-if="item.pgSubject">{{ item.pgSubject }}</span>
              <span>{{ item.enrolYear }}</span>
            </div>
            <ul v-if="item.keywords">
              <li v-for="(words, index1) in keywordsList(item.keywords)" :key="index1">
                {{ words }}
              </li>
            </ul>
          </div>
        </div>
      </van-list>
    </div>
    <div class="quickMatch" v-if="!listEmpty">
      <div @click="openChat">快速匹配</div>
    </div>

    <EmptyData :emptyName="'noEvaluation'" v-if="listEmpty" />
    <MiniLogin
      @loginCallBack="miniloginCallBack"
      :visible="showLogin"
      @loginClose="hideminiLoginModal"
    />
  </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { reqSeniorList, reqMajorMath, reqSchoolList } from '@/api/majorSenior';
// import CommonTitle from '@/components/header/CommonTitle.vue';
import { seniorOpenChat, setTokenFromCookie, gioPlatform } from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';
import SchoolCard from './components/schoolCard.vue';
import MiniLogin from '../miniLogin/index.vue'
import wx from 'weixin-js-sdk';

export default {
  components: {
    // CommonTitle,
    EmptyData,
    SchoolCard,
    MiniLogin
  },
  data() {
    return {
      pageData: {
        pageNum: 1,
        pageSize: 10,
      },
      seniorList: [],
      defaultHead: require('@/assets/img/majorSenior/headIcon.png'), // 默认头像
      loading: false,
      finished: false,
      listEmpty: false, // 是否展示缺省页
      seniorId: '',
      searchVal: '', // 搜索内容
      showSearch: false,
      searchList: [], // 搜索的专业列表
      selected: -99,
      shchoolInfo: {},
      pgSubject: '',
      seniorDetail: {},
      showLogin: false,
    };
  },

  computed: {
    ...mapState(['userInfo']),
  },
  created() {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);

  },

  methods: {
     // 登录回调
     miniloginCallBack(user){
      wx.miniProgram.postMessage({ data: {accessToken: localStorage.getItem('accessToken')} })
      this.hideminiLoginModal()
    },
    showminiLoginModal(){
      this.showLogin = true;
    },

    hideminiLoginModal(){
      this.showLogin = false;
    },

    back() {
      this.$router.go(-1);
    },
    change() {
      console.log('input', this.searchVal);
      this.pageData.pageNum = 1;
      if (!this.searchVal) {
        this.pgSubject = '';
        this.seniorList = [];
        this.listEmpty = false;
        this.getSeniorList();
        return;
      }
      this.showSearch = true;
      this.getMajorList();
    },
    addClass(index, name) {
      this.selected = index;
      this.pgSubject = name;
      this.searchVal = name;
      this.showSearch = false;
      this.seniorList = [];
      this.getSeniorList();
    },
    keywordsList(item) {
      return item.split(',');
    },
    // 搜索专业
    async getMajorList() {
      const { data } = await reqMajorMath(this.searchVal);
      console.log(data, 999);
      this.searchList = data || [];
    },
    // 查询学长学姐列表
    async getSeniorList() {
      const { pageNum, pageSize } = this.pageData;
      const { pgSubject, shchoolInfo } = this;
      console.log();
      const res = await reqSeniorList({
        pageNum,
        pageSize,
        pgCollege: shchoolInfo.name,
        pgSubject,
      });
      if (res?.code === 0) {
        this.loading = false;

        this.seniorList = this.seniorList.concat(res?.data?.data);
        // eslint-disable-next-line
        this.pageData.pageNum++;
        // 如果加载完毕，显示没有更多了
        const { total } = res.data;
        if (this.seniorList.length >= total) {
          this.finished = true;
        }
        if (!total) {
          this.listEmpty = true;
        }
      }
    },
    // 学长学姐详情页
    goSeniorDetail(seniorId, nickName, item) {
      sessionStorage.setItem('SeniorDetail', true);
      // eslint-disable-next-line no-undef
      gio('evar.set', 'SeniorAndsister_evar', nickName);
      this.seniorId = seniorId;
      this.seniorDetail = item;
      this.SeniorClick_event();
      if(this.$root.whatEev=='miniprogram'){
        this.openPersonDetail(seniorId);
        return
      }
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
          });
        } else {
          const param = { redirect: '/personDetail', seniorId };
          const routeUrl = this.$router.resolve({
            path: '/ark/registrationLogin',
            query: param,
          });
          window.top.open(routeUrl.resolved.fullPath);
        }
      } else {
        this.openPersonDetail(seniorId);
      }
    },



    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter(this.seniorId);
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      setTimeout(() => {
        this.openPersonDetail(this.seniorId);
      }, 500);
    },
    openPersonDetail(seniorId) {
      const routeUrl = this.$router.resolve({
        path: '/ark/personDetail',
        query: { seniorId },
      });
      const { isApp = false } = this.$root.$data;
      if (isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `${window.location.origin}${routeUrl.resolved.fullPath}`,
          },
          false,
        );
      } else {
        window.top.open(routeUrl.resolved.fullPath);
      }
    },
    // 列表加载
    onLoad() {
      setTimeout(async () => {
        if (!this.shchoolInfo?.id) {
          await this.getSchoolList();
        }
        this.loading = true;
        this.getSeniorList();
      }, 500);
    },

    // 快速匹配
    openChat() {
      if (this.$root.whatEev == 'miniprogram') {
        wx.miniProgram.navigateTo({ url: '/subPackages/aiChatWebview/index?probeId=33'});
      } else {
        seniorOpenChat(this);
      }
    },
    // 查下当前学校下的学姐们
    async getSchoolList() {
      if (!this.$route.query.name) {
        this.$router.replace({
          path: '/university',
        });
        return;
      }
      const { code, data } = await reqSchoolList(this.$route.query.name, 1, 10);
      if (code === 0) {
        this.shchoolInfo = data?.data?.[0];
      }
    },
    SeniorClick_event() {
      const { realName, nickName, pgCollege, pgSubject } = this.seniorDetail;
      // eslint-disable-next-line no-undef
      gio('track', 'SeniorClick_event', {
        name_var: realName, // 广告位置
        nickname_var: nickName,
        GraduateSchool_var: pgCollege,
        GraduateProgram_var: pgSubject,
        PlatformType_var: gioPlatform(),
      });
    },
    closeBg(el) {
      if (el.target === el.currentTarget) {
        this.searchVal = '';
        this.searchList = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.majorSenior.fix {
  position: fixed;
}
.majorSenior.inApp {
  .top-head {
    height: 300px;
    .back {
      display: none;
    }
  }
  .schoolList {
    top: 300px;
  }
}
.majorSenior {
  width: 100%;
  padding-top: 350px;
  .mainBox {
    box-sizing: border-box;
    width: 100%;
    padding: 29px 36px 167px 26px;
    // overflow-y: auto;
    .seniorBox {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 22px;
      padding: 36px 36px 40px 36px;
      background: #fff;
      border-radius: 14px;
      .headerIcon {
        width: 120px;
        margin-right: 36px;
        img {
          width: 120px;
          height: 122px;
          border-radius: 50%;
        }
      }
      .seniorInfo {
        h2 {
          color: #333;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
        }
        .schoolDetail {
          padding: 16px 0 18px 0;
          font-size: 0;
          span {
            position: relative;
            margin-right: 25px;
            color: #666;
            font-weight: 400;
            font-size: 25px;
            line-height: 36px;
            word-wrap: break-word;
            word-break: break-all;
            &::before {
              position: absolute;
              top: 6px;
              left: -14px;
              width: 2px;
              height: 22px;
              background: #666;
              content: '';
            }
            &:first-child::before {
              content: none;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            margin-right: 10px;
            margin-bottom: 14px;
            padding: 7px;
            color: #fe9766;
            font-weight: 400;
            font-size: 22px;
            line-height: 31px;
            background: #fef5f1;
            border-radius: 7px;
          }
        }
      }
    }
  }
  .quickMatch {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 35px 0 50px 0;
    background: #fff;
    border-radius: 29px 29px 2px 2px;
    box-shadow: 0 -4px 18px 0 rgba(0, 0, 0, 0.07);
    div {
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 45px;
    }
  }
}
.top-head {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 350px;
  background: #ffefe7;
  .title {
    width: 750px;
    height: 350px;
    padding: 36px;
    .back {
      width: 43px;
      height: 43px;
    }
    .bg {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 339px;
      height: 212px;
    }
    .search {
      position: relative;
      margin: 18px 0 0 0;
    }
    .search::before {
      position: absolute;
      top: 18px;
      left: 22px;
      z-index: 10;
      display: block;
      width: 29px;
      height: 29px;
      background: url('../../assets/img/majorSenior/search.png') no-repeat;
      background-size: 100%;
      content: '';
    }
  }
  ::v-deep .listshchoolInfo {
    margin: 0;
    padding: 0;
    background: none;
  }
}
.schoolList {
  position: absolute;
  top: 350px;
  left: 0;
  z-index: 10000;
  width: 750px;
  height: calc(100vh - 350px);
  overflow: hidden;
  background: rgba($color: #000, $alpha: 0.5);
  > div {
    height: 740px;
    overflow-y: auto;
    background: #fff;
    border-radius: 0 0 36px 36px;

    > div {
      padding: 0 0 0 36px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 91px;
    }
  }
  div.active {
    color: #ff7f41;
    background: #fff3ee;
  }
}
.minichat{
  .majorSenior{
    padding-top: 320px;
    .top-head{
    height: auto;
    .title{
      height: auto;
    }
  }
  }

}
::v-deep .van-field__control {
  width: 339px;
  height: 32.5px;
  padding-left: 32.5px;
  color: #999;
  font-weight: 400;
  font-size: 14px;
  background: #fff;
  border-radius: 7px;
}
::v-deep .van-cell {
  padding: 0;
  border-radius: 7px;
}
::v-deep .emptyIndent {
  height: 400px;
  margin-top: 100px;
}
::v-deep .emptyIndent .hide {
  display: none;
}
</style>
